import {Component, OnInit} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Page} from "../util/Page";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {Pageable} from "../util/Pageable";
import {PageEvent} from "@angular/material/paginator";

@Component({
    selector: 'app-customer',
    templateUrl: './customer.component.html',
    styleUrls: ['./customer.component.css'],
    standalone: false
})
export class CustomerComponent implements OnInit {
  allCustomers: any = [];
  length: number = 0;
  pageSize: number = 10;
  pageEvent: any;
  displayedColumns: string[] = ['id', 'name'];

  constructor(private http: HttpClient) {
  }

  getCustomers(pageable: Pageable): Observable<Page<Customer[]>> {
    const options = pageable ?
      {params: new HttpParams().set('page', pageable.page).set('size', pageable.size)} : {};

    return this.http.get<Page<Customer[]>>(environment.apiURL + '/cc/customers?sort=name,asc', options);
  }

  ngOnInit(): void {
    this.getCustomers(new Pageable(0, this.pageSize)).subscribe({
      next: (response) => {
        this.allCustomers = response.content;
        this.length = response.totalElements;
      }
    });
  }

  onPaginateChange($event: PageEvent) {
    this.getCustomers(new Pageable($event.pageIndex, $event.pageSize)).subscribe({
      next: (response) => {
        this.allCustomers = response.content;
      }
    });
  }
}

export interface Customer {
  name: string;
  id: string;
}
